module.exports = __webpack_public_path__ + "static/easyeducation-env-coolStudent-4a20afe5962b891f9964dce911c3f968.jpg";